import _extends from "@babel/runtime/helpers/extends";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/SkeletonLoader/preset.js",
  _this = this;
import React from 'react';
import ContentLoader from 'react-content-loader';
import Card from '../Card';
import styled from 'styled-components';
import { testIdProps } from '../../helpers';
var LoaderContainer = styled.div.withConfig({
  displayName: "preset__LoaderContainer",
  componentId: "sc-m3jkqu-0"
})(["display:flex;"]);
export var ListItem = function ListItem(p) {
  return /*#__PURE__*/React.createElement(Card, _extends({}, testIdProps(p), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 3
    }
  }), /*#__PURE__*/React.createElement(LoaderContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ContentLoader, _extends({}, defaultSkeletonLoaderProps, {
    viewBox: "0 0 312 96",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "16",
    y: "16",
    rx: "8",
    ry: "8",
    width: "64",
    height: "64",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "100",
    y: "18",
    rx: "8",
    ry: "8",
    width: "60",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "100",
    y: "53",
    rx: "8",
    ry: "8",
    width: "195",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }))));
};
export var CardSkeleton = function CardSkeleton(p) {
  return /*#__PURE__*/React.createElement(Card, _extends({
    padding: "md"
  }, testIdProps(p), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 3
    }
  }), /*#__PURE__*/React.createElement(LoaderContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ContentLoader, _extends({}, defaultSkeletonLoaderProps, {
    viewBox: "0 0 327 232",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "24",
    y: "24",
    rx: "8",
    ry: "8",
    width: "128",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "24",
    y: "64",
    rx: "8",
    ry: "8",
    width: "64",
    height: "64",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "24",
    y: "152",
    rx: "8",
    ry: "8",
    width: "280",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "24",
    y: "192",
    rx: "8",
    ry: "8",
    width: "280",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }))));
};
export var CardWithBanner = function CardWithBanner(p) {
  return /*#__PURE__*/React.createElement(Card, _extends({
    padding: "md",
    radius: "md"
  }, testIdProps(p), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 3
    }
  }), /*#__PURE__*/React.createElement(LoaderContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ContentLoader, _extends({}, defaultSkeletonLoaderProps, {
    viewBox: "0 0 327 312",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "0",
    ry: "0",
    width: "327",
    height: "184",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "24",
    y: "216",
    rx: "8",
    ry: "8",
    width: "280",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "24",
    y: "264",
    rx: "8",
    ry: "8",
    width: "280",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }))));
};
export var Tabs = function Tabs(p) {
  return /*#__PURE__*/React.createElement("div", _extends({}, testIdProps(p), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(LoaderContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ContentLoader, _extends({}, defaultSkeletonLoaderProps, {
    viewBox: "0 0 375 52",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "184",
    y: "24",
    rx: "8",
    ry: "8",
    width: "120",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "24",
    y: "24",
    rx: "8",
    ry: "8",
    width: "120",
    height: "16",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "48",
    rx: "2",
    ry: "2",
    width: "375",
    height: "5",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 11
    }
  }))));
};
var defaultSkeletonLoaderProps = {
  width: '100%',
  height: '100%',
  speed: 5,
  backgroundColor: '#F7F7F7',
  foregroundColor: '#E1E1E1'
};
export default {
  Card: CardSkeleton,
  CardWithBanner: CardWithBanner,
  ListItem: ListItem,
  Tabs: Tabs
};